import Vue from 'vue'  
import App from './App.vue'  
import router from './router'  
import store from './store'  
import vuetify from './plugins/vuetify'  
import axios from 'axios'  

// 绑定Axios到Vue原型  
Vue.prototype.$axios = axios  

// 配置Axios默认值（可选）  
axios.defaults.baseURL = '' // 替换为你的API基础UR = 在基础页面上即可进行后端数据接口的路由配置 
// axios.defaults.headers.common['Authorization'] = 'Bearer YOUR_TOKEN' // 替换为你的令牌（如果需要）  

Vue.config.productionTip = false  

new Vue({  
  router,  
  store,  
  vuetify, 
  render: h => h(App)
}).$mount('#app')  
